import React from "react";
import PropTypes from "prop-types";
import numberFormatter from "common/number-formatter";

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  attr: PropTypes.oneOf(["impressions", "clicks", "videoStarts"]).isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    })
  ),
  breakdown: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      impressions: PropTypes.number,
      clicks: PropTypes.number,
      videoStarts: PropTypes.number
    })
  )
};

const PerformanceStatTile = ({ label, value = 0, attr, products = [], breakdown = [] }) => {
  const showBreakdown = products.length > 1;
  const breakdownByKey = new Map(breakdown.map(stat => [stat.key, stat]));

  return (
    <div className="performance-stat-tile">
      <div className="performance-stat-tile__label">{label}</div>
      <div className="performance-stat-tile__value">{numberFormatter.toLocaleString(value)}</div>
      {showBreakdown && (
        <div className="performance-stat-tile__breakdown">
          {products.map(product => {
            const productStat = breakdownByKey.get(product.key);
            return (
              <div className="performance-stat-tile__breakdown-item" key={product.key}>
                <span
                  className="performance-stat-tile__breakdown-swatch"
                  style={{ backgroundColor: product.color }}
                />
                <span className="performance-stat-tile__breakdown-label">{product.label}:</span>
                <span className="performance-stat-tile__breakdown-value">
                  {numberFormatter.toLocaleString(productStat ? productStat[attr] : 0)}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

PerformanceStatTile.propTypes = propTypes;

export default PerformanceStatTile;
